import { useTranslation } from 'react-i18next';

import { WarningBanner } from '../banners/WarningBanner';
import { FaIcon } from '../icons/FaIcon';
import { LoadingRetryButton } from './LoadingRetryButton';

export type LoadingFailedBannerProps = {
  onRetry?: () => void | Promise<void>;
};

export function LoadingFailedBanner({ onRetry }: LoadingFailedBannerProps) {
  const { t } = useTranslation();

  return (
    <WarningBanner>
      <span>
        <FaIcon icon="fal fa-warning" /> {t('Loading_GeneralLoadingFailedMessage')}
      </span>
      {onRetry != null && <LoadingRetryButton size="small" type="warning" onRetry={onRetry} />}
    </WarningBanner>
  );
}
